export const stockParams = [
  {
    key: 'symbol', label: 'Symbol', thClass: 'text-center align-middle ', thStyle: { minWidth: '6rem' },
  },
  {
    key: 'company_name', label: 'Company Name', thClass: 'text-center align-middle ', thStyle: { minWidth: '14rem' },
  },
  {
    key: 'sector', label: 'Sector', thClass: 'text-center align-middle ', thStyle: { minWidth: '12rem' },
  },
  {
    key: 'industry', label: 'Industry', thClass: 'text-center align-middle ', thStyle: { minWidth: '12rem' },
  },
  {
    key: 'exchange', label: 'Exchange', thClass: 'text-center align-middle ', thStyle: { minWidth: '12rem' },
  },
  {
    key: 'market_cap', label: 'Market Cap', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' },
  },
  {
    key: 'dividend_yield', label: 'Dividend Yield', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'dividend_yield_avg_5yr', label: 'Dividend Yield Avg 5 Years', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'dividend_yield_avg_10yr', label: 'Dividend Yield Avg 10 Years', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'dividend_growth_5yr_cagr', label: 'Dividend Growth 5 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'dividend_growth_10yr_cagr', label: 'Dividend Growth 10 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'dividend_growth_streak', label: 'Dividend Growth Streak', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' },
  },
  {
    key: 'earnings_payout_ratio', label: 'Earnings Payout Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'fcf_payout_ratio', label: 'FCF Payout Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'revenue_growth_5yr_cagr', label: 'Revenue Growth 5 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'revenue_growth_10yr_cagr', label: 'Revenue Growth 10 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'eps_growth_5yr_cagr', label: 'EPS Growth 5 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'eps_growth_10yr_cagr', label: 'EPS Growth 10 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'fcf_growth_5yr_cagr', label: 'FCF Growth 5 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'fcf_growth_10yr_cagr', label: 'FCF Growth 10 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'fcf_per_share_growth_5yr_cagr', label: 'FCF Per Share Growth 5 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'fcf_per_share_growth_10yr_cagr', label: 'FCF Per Share Growth 10 CAGR', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'fcf_to_revenue_ratio', label: 'FCF to Revenue Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'roic_avg_5yr', label: 'ROIC Avg 5 Years', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'roic_avg_10yr', label: 'ROIC Avg 10 Years', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'roic', label: 'ROIC', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'roe', label: 'ROE', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'roa', label: 'ROA', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isPercentage: true,
  },
  {
    key: 'debt_to_ebitda_ratio', label: 'Debt to EBITDA Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'net_debt_to_ebitda_ratio', label: 'Net Debt to EBITDA Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'interest_coverage_ratio', label: 'Interest Coverage Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'debt_to_equity_ratio', label: 'Debt to Equity Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'current_ratio', label: 'Current Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'price_to_earnings_ratio', label: 'Price to Earnings Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'price_to_fcf_ratio', label: 'Price to FCF Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'ev_to_ebitda_ratio', label: 'EV to EBITDA Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
  {
    key: 'cape_ratio', label: 'CAPE Ratio', thClass: 'text-center align-middle ', thStyle: { minWidth: '8rem' }, isRatio: true,
  },
];

export const exchangeList = [
  'Brussels',
  'Madrid Stock Exchange',
  'Nasdaq',
  'NASDAQ Capital Market',
  'NASDAQ Global Market',
  'NASDAQ Global Select',
  'New York Stock Exchange',
  'Paris',
  'SES',
  'Toronto Stock Exchange',
  'TSXV',
];

export const industryList = [
  'Advertising Agencies',
  'Aerospace & Defense',
  'Agricultural Inputs',
  'Airlines',
  'Airports & Air Services',
  'Aluminum',
  'Apparel Manufacturing',
  'Apparel Retail',
  'Asset Management',
  'Auto & Truck Dealerships',
  'Auto Manufacturers',
  'Auto Parts',
  'Banks—Diversified',
  'Banks—Regional',
  'Beverages—Brewers',
  'Beverages—Non-Alcoholic',
  'Beverages—Wineries & Distilleries',
  'Biotechnology',
  'Broadcasting',
  'Building Materials',
  'Building Products & Equipment',
  'Business Equipment & Supplies',
  'Capital Markets',
  'Chemicals',
  'Closed-End Fund - Equity',
  'Coking Coal',
  'Communication Equipment',
  'Computer Hardware',
  'Confectioners',
  'Conglomerates',
  'Consulting Services',
  'Consumer Electronics',
  'Copper',
  'Credit Services',
  'Department Stores',
  'Diagnostics & Research',
  'Discount Stores',
  'Drug Manufacturers—General',
  'Drug Manufacturers—Specialty & Generic',
  'Education & Training Services',
  'Electrical Equipment & Parts',
  'Electronic Components',
  'Electronic Gaming & Multimedia',
  'Electronics & Computer Distribution',
  'Engineering & Construction',
  'Entertainment',
  'Farm & Heavy Construction Machinery',
  'Farm Products',
  'Financial Conglomerates',
  'Financial Data & Stock Exchanges',
  'Food Distribution',
  'Footwear & Accessories',
  'Furnishings, Fixtures & Appliances',
  'Gambling',
  'Gold',
  'Grocery Stores',
  'Healthcare Plans',
  'Health Information Services',
  'Homebuilding & Construction',
  'Home Improvement Retail',
  'Household & Personal Products',
  'Industrial Distribution',
  'Information Technology Services',
  'Infrastructure Operations',
  'Insurance Brokers',
  'Insurance—Diversified',
  'Insurance—Life',
  'Insurance—Property & Casualty',
  'Insurance—Reinsurance',
  'Insurance—Specialty',
  'Integrated Freight & Logistics',
  'Internet Content & Information',
  'Internet Retail',
  'Leisure',
  'Lodging',
  'Lumber & Wood Production',
  'Luxury Goods',
  'Marine Shipping',
  'Medical Care Facilities',
  'Medical Devices',
  'Medical Distribution',
  'Medical Instruments & Supplies',
  'Metal Fabrication',
  'Mortgage Finance',
  'Oil & Gas Drilling',
  'Oil & Gas E&P',
  'Oil & Gas Equipment & Services',
  'Oil & Gas Integrated',
  'Oil & Gas Midstream',
  'Oil & Gas Refining & Marketing',
  'Other Industrial Metals & Mining',
  'Other Precious Metals & Mining',
  'Packaged Foods',
  'Packaging & Containers',
  'Paper & Paper Products',
  'Personal Services',
  'Pharmaceutical Retailers',
  'Pollution & Treatment Controls',
  'Publishing',
  'Railroads',
  'Real Estate Services',
  'Real Estate—Development',
  'Real Estate—Diversified',
  'Recreational Vehicles',
  'REIT—Diversified',
  'REIT—Healthcare Facilities',
  'REIT—Hotel & Motel',
  'REIT—Industrial',
  'REIT—Mortgage',
  'REIT—Office',
  'REIT—Residential',
  'REIT—Retail',
  'REIT—Specialty',
  'Rental & Leasing Services',
  'Residential Construction',
  'Resorts & Casinos',
  'Restaurants',
  'Retail Apparel & Specialty',
  'Scientific & Technical Instruments',
  'Security & Protection Services',
  'Semiconductor Equipment & Materials',
  'Semiconductors',
  'Shell Companies',
  'Silver',
  'Software—Application',
  'Software—Infrastructure',
  'Solar',
  'Specialty Business Services',
  'Specialty Chemicals',
  'Specialty Industrial Machinery',
  'Specialty Retail',
  'Staffing & Employment Services',
  'Steel',
  'Telecom Services',
  'Telecom Services - Foreign',
  'Textile Manufacturing',
  'Thermal Coal',
  'Tobacco',
  'Tools & Accessories',
  'Travel Services',
  'Trucking',
  'Uranium',
  'Utilities Regulated',
  'Utilities—Diversified',
  'Utilities—Independent Power Producers',
  'Utilities—Regulated Electric',
  'Utilities—Regulated Gas',
  'Utilities—Regulated Water',
  'Utilities—Renewable',
  'Waste Management',
];

export const sectorList = [
  'Real Estate',
  'Healthcare',
  'Basic Materials',
  'Consumer Cyclical',
  'Energy',
  'Industrials',
  'Utilities',
  'Technology',
  'Financial Services',
  'Consumer Defensive',
  'Communication Services',
];
